import { render, staticRenderFns } from "./FinanceProduct.vue?vue&type=template&id=b0328e68&scoped=true&"
import script from "./FinanceProduct.vue?vue&type=script&lang=js&"
export * from "./FinanceProduct.vue?vue&type=script&lang=js&"
import style0 from "./FinanceProduct.vue?vue&type=style&index=0&id=b0328e68&lang=less&scoped=true&"
import style1 from "./FinanceProduct.vue?vue&type=style&index=1&id=b0328e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0328e68",
  null
  
)

export default component.exports